module.exports = __webpack_public_path__ + "img/777C61_333727_BABFA1_A5AC8C-256px.0532bb1e.png";